__webpack_require__.p = "https://uat.user.byonde.asia/";